<template>
  <el-dialog v-loading="isLoading" title="設定網址路徑" append-to-body :visible.sync="mIsShow">

    <label>貼文網址</label>
    <el-input v-model="mURLKey" @input="onInput" placeholder="請輸入網址路徑" />
    <!-- 顯示錯誤 -->
    <small style="display: block;margin-top: 6px;"><font color="black">備註: </font>路徑不可設定斜線(/)</small>
    <small v-if="mError" style="display: block;margin-top: 6px;"><font color="red">錯誤: </font>{{mError}}</small>
    <small style="display: block;margin-top: 6px;">產地情報網址將設定為以下: <br>https://www.syunkaya.com.tw/origin-info/{{mURLKey}}</small>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button :disabled="mError!=null" type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    urlKey: {
      default: ''
    }
  },
  data () {
    return {
      mURLKey: '',
      mIsShow: false,
      isLoading: false,
      mError: null
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onInput () {
      this.mURLKey = this.mURLKey.replace(/\//g, '')
      this.recheckError()
    },
    recheckError () {
      if (this.mURLKey) {
        // 檢查重複
        let idx = this.$store.state.originInfo.list.findIndex(o => o.UrlKey === this.mURLKey)
        if (idx >= 0) {
          this.mError = '商品路徑已存在'
        } else {
          this.mError = null
        }
      } else {
        this.mError = '不可留空'
      }
    },
    submit () {
      this.$emit('submit', this.mURLKey)
      this.close()
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        this.mURLKey = this.urlKey
        this.recheckError()
      }
    }
  }
}
</script>
